import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SharedService {

    // Sidebar visibility
    sidebarVisible: boolean;
    sidebarVisibilitySubject: Subject<boolean> = new Subject<boolean>();
    // Previous scales sidebar visibility
    sidebarPreviousScalesVisible: boolean;
    sidebarPreviousScalesVisibilitySubject: Subject<boolean> = new Subject<boolean>();

    toggleSidebarVisibilty() {
        this.sidebarVisible = !this.sidebarVisible;
        this.sidebarVisibilitySubject.next(this.sidebarVisible);
    }

    showSidebar() {
        this.sidebarVisible = true;
        this.sidebarVisibilitySubject.next(this.sidebarVisible);
    }

    hideSidebar() {
        this.sidebarVisible = false;
        this.sidebarVisibilitySubject.next(this.sidebarVisible);
    }

    showPreviousScalesSidebar() {
        this.sidebarPreviousScalesVisible = true;
        this.sidebarPreviousScalesVisibilitySubject.next(this.sidebarPreviousScalesVisible);
    }

    hidePreviousScalesSidebar() {
        this.sidebarPreviousScalesVisible = false;
        this.sidebarPreviousScalesVisibilitySubject.next(this.sidebarPreviousScalesVisible);
    }

    constructor()  {
        // Hidden the sidebar by default
        this.sidebarVisible = false;
        this.sidebarPreviousScalesVisible = false;
    }
}
